module.exports = __webpack_public_path__ + "img/style-3.5c11d42b.jpg";